var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"home-banner"},[_c('div',{staticClass:"home-banner__container"},[_c('div',{staticClass:"home-banner__content"},[_c('h1',{staticClass:"home-banner__heading"},[_c('span',{staticClass:"home-banner__logo"},[_vm._v("THINK")]),_vm._v(" "+_vm._s(_vm.title)+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }